export default class AuthenticateModel {
	account: string = ''
	password: string = ''
	openId: string = ''
	isWX: boolean = false
}
